import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

export const Spinner = defineStyleConfig({
  defaultProps: {
    size: 'lg',
    variant: 'primary',
  },
  variants: {
    primary: defineStyle({
      color: 'primary.500',
      margin: 'auto',
    }),
  },
});
